export const resources = {
  Preview: ''
};
